"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MeasurementsPanel;

var _react = require("@chakra-ui/react");

var _react2 = _interopRequireWildcard(require("react"));

var _sliderFormControl = _interopRequireDefault(require("../slider-form-control"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function MeasurementsPanel(props) {
  var value = props.value,
      minLuft = props.minLuft,
      maxLuft = props.maxLuft,
      minV = props.minV,
      maxV = props.maxV,
      minH = props.minH,
      maxH = props.maxH,
      onChange = props.onChange;
  var luftError = (0, _react2.useMemo)(function () {
    if (value.luft > maxLuft) return "Karmbredd är för liten";
    if (value.luft < minLuft) return "Karmbredd är för stor";
  }, [value.luft, maxLuft]);
  var vError = (0, _react2.useMemo)(function () {
    if (value.v < minV) {
      return "Karmbredd m\xE5ste vara minst ".concat(Math.ceil(minV), " mm");
    }

    if (value.v > maxV) {
      return "Karmbredd m\xE5ste vara h\xF6gst ".concat(Math.floor(maxV), " mm");
    }

    return null;
  }, [value.v, minV, maxV]);
  var hError = (0, _react2.useMemo)(function () {
    if (value.h < minH) {
      return "Karmh\xF6jd m\xE5ste vara minst ".concat(Math.ceil(minH), " mm");
    }

    if (value.h > maxH) {
      return "Karmh\xF6jd m\xE5ste vara h\xF6gst ".concat(Math.floor(maxH), " mm");
    }

    return null;
  }, [value.h, minH]);

  var setLuft = function setLuft(luft) {
    onChange(_objectSpread(_objectSpread({}, value), {}, {
      luft: luft
    }));
  };

  var setV = function setV(v) {
    onChange(_objectSpread(_objectSpread({}, value), {}, {
      v: v
    }));
  };

  var setH = function setH(h) {
    onChange(_objectSpread(_objectSpread({}, value), {}, {
      h: h
    }));
  };

  return /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    direction: "column",
    spacing: 4
  }, /*#__PURE__*/_react2.default.createElement(_sliderFormControl.default, {
    label: "Antal luft",
    value: value.luft,
    min: 1,
    max: 6,
    step: 1,
    onChange: function onChange(val) {
      return setLuft(val);
    },
    error: luftError
  }), /*#__PURE__*/_react2.default.createElement(_react.FormControl, {
    isInvalid: !!vError
  }, /*#__PURE__*/_react2.default.createElement(_react.FormLabel, null, "Karmbredd"), /*#__PURE__*/_react2.default.createElement(_react.NumberInput, {
    value: value.v,
    min: minV,
    max: maxV,
    onChange: function onChange(_value, valueAsNumber) {
      return setV(valueAsNumber || 0);
    },
    keepWithinRange: false,
    clampValueOnBlur: false,
    errorBorderColor: "orange.100"
  }, /*#__PURE__*/_react2.default.createElement(_react.NumberInputField, null), /*#__PURE__*/_react2.default.createElement(_react.NumberInputStepper, null, /*#__PURE__*/_react2.default.createElement(_react.NumberIncrementStepper, null), /*#__PURE__*/_react2.default.createElement(_react.NumberDecrementStepper, null))), vError ? /*#__PURE__*/_react2.default.createElement(_react.FormErrorMessage, {
    textColor: "orange.500"
  }, vError) : null), /*#__PURE__*/_react2.default.createElement(_react.FormControl, {
    isInvalid: hError
  }, /*#__PURE__*/_react2.default.createElement(_react.FormLabel, null, "Karmh\xF6jd"), /*#__PURE__*/_react2.default.createElement(_react.NumberInput, {
    value: value.h,
    min: minH,
    max: maxH,
    onChange: function onChange(_value, valueAsNumber) {
      return setH(valueAsNumber || 0);
    },
    keepWithinRange: false,
    clampValueOnBlur: false,
    errorBorderColor: "orange.100"
  }, /*#__PURE__*/_react2.default.createElement(_react.NumberInputField, null), /*#__PURE__*/_react2.default.createElement(_react.NumberInputStepper, null, /*#__PURE__*/_react2.default.createElement(_react.NumberIncrementStepper, null), /*#__PURE__*/_react2.default.createElement(_react.NumberDecrementStepper, null))), hError ? /*#__PURE__*/_react2.default.createElement(_react.FormErrorMessage, {
    textColor: "orange.500"
  }, hError) : null));
}